export const props = {
    config: {
      type: [Boolean, Function, Object],
      default: () => ({})
    },
    id: {
      type: [String, Function],
    },
    message: {
      type: [String, Function],
    },
    title: {
      type: [String, Function],
    },
    denyLabel: {
      type: [String, Function],
    },
    confirmLabel: {
      type: [String, Function],
    },
    confirmed: {
      type: [Function],
    },
    denied: {
      type: [Function],
      default: null,
    },
    containerClass: {
      type: [Array, String, Object],
      default: 're-modal-md'
    },
    noClose: {
      type: [Boolean, Function],
      default: false
    }
  }
export default {
  name: 're-confirm',
  props,
  data() {
    return {}
  },
  computed: {
    options() {
      return _.defaultsDeep({}, this.config || {}, _.pick(this, _.keys(_.omit(props, ['config']))))
    }
  },
  created() {

  },
  methods: {
    confirm() {
      this.respond(true)
    },
    deny() {
      this.respond(false)
    },
    respond(state) {
      const {then, confirmed} = this.options
      then && then(state)
      confirmed && confirmed(state)
      this.close(state)
    },
    close(state = false) {
      this.$emit('close', state)
    }
  }
}
